import { Axios } from 'axios'
import { RootState } from '@/store'
import { Kamoku } from '@/repositories/fuzoku-meisai/data'
import {
  ResponseMokurokuSetting
} from '@/repositories/fuzoku-meisai/kaikei-kijun/data'

export type PostParam = {
  landOwnershipStatus: string;
  buildingOwnershipStatus: string;
  currentAssets: Kamoku[];
  fixedAssets: Kamoku[];
  totalDebt: Kamoku[];
}

export interface MokurokuRepository {
  list (): Promise<ResponseMokurokuSetting>;

  save (postData: PostParam): Promise<void>;
}

export class MokurokuRepositoryImpl implements MokurokuRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/mokuroku`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  async list (): Promise<ResponseMokurokuSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (param: PostParam): Promise<void> {
    await this.http.post(this.baseUrl, param)
  }
}
